<template>
  <div class="page-content">
    <!-- <p class="newMine_pageTitle">我的课程</p> -->
    <div class="page-course-header d-flex d-flex-middle d-flex-between" style="align-items: end;">
      <p class="newMine_pageTitle newMine_pageTitleb ">
        <span class="newMine_pageTitles">我的课程</span>
      </p>
      <div style="padding:0 30px;">
        <el-form ref="form" :model="form" label-width="auto">
          <el-form-item label="考次" size="small" class="mb0">
            <el-select v-model="form.examConfigId" placeholder="请选择" @change="changeExamConfig">
              <el-option :label="item.name" :value="item.id" v-for="(item, index) in examConfigList"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="newMine_base_tabs d-flex d-flex-middle d-flex-center">
      <p v-for="(e, i) in tabs" :key="i" @click="tabClick(e)" :class="{ 'on': e.id == isOn }">{{ e.name }}<i
          :class="{ 'bgColor': e.id == isOn }"></i></p>
    </div>
    <div class="enroll-time" v-if="currentExamConfig && currentExamConfig.studyStartTime">
      学习时间：{{ currentExamConfig.studyStartTime }} - {{ currentExamConfig.studyEndTime }}
    </div>
    <div class="newMine_coursePage_list">
      <div class="newMine_coursePage_li d-flex d-flex-middle d-flex-between" v-for="(c, i) in list" :key="i">
        <div class="newMine_coursePage_li_l d-flex d-flex-middle d-flex-between">
          <img :src="c.logo||courseLogo" class="newMine_coursePage_li_img">
          <div class="newMine_coursePage_li_info">
            <p class="newMine_coursePage_li_info_name txtOver">{{c.code}}-{{ c.name }}</p>
            <div class="newMine_coursePage_li_info_desc d-flex d-flex-middle">
              <div class="newMine_coursePage_li_info_descLi d-flex d-flex-middle">
                <img src="../assets/login/mine_play.png" class="newMine_coursePage_li_info_icon">
                <p>【课件】</p>
                <p>课时：{{ c.sumChapters ? c.sumChapters + '章':'' }}{{ c.sumLessons ? c.sumLessons + '节':'' }}</p>
              </div>
              <!-- <p class="newMine_coursePage_li_info_descLi">最近观看时间： {{ c.time }}</p> -->
            </div>
            <div class="newMine_coursePage_li_info_line d-flex d-flex-middle">
              <p class="newMine_coursePage_li_info_lineTxt color" style="color: #0065BA;">已学：{{ c.ratio||0 }}%</p>
              <div class="newMine_coursePage_li_info_lineBox d-flex d-flex-middle borderColor"
                style="border-color: #0065BA;">
                <p :style="`width: ${c.ratio||0}%;`"></p>
              </div>
            </div>
          </div>
        </div>
        <a v-if="inStudyTime || isOn === '-1'" href="javascript:void(0);" @click="toStudy(c)" class="newMine_BoxLi_btn bgColor"
          style="background-color: #0065BA;">开始学习</a>
      </div>
    </div>
    <faceRecognition ref="faceRecognition" type="kj" @submit="toStudys" ></faceRecognition>
    <PayDialog ref="payDialog" @refresh="getData" />

    <FightersAgreementDialog
      ref="FightersAgreementDialog"
      @confirm="onPledgeConfirm"
    />
  </div>
</template>

<script>
import { mapState } from "vuex"
import faceRecognition from "@/components/faceRecognition.vue";
import PayDialog from './registrationPayDialog.vue'
import FightersAgreementDialog from "@/components/FightersAgreementDialog.vue";
import { getServerCurrentTime } from "@/utils/utils.js";

export default {
  components: {
    faceRecognition,
    PayDialog,
    FightersAgreementDialog
  },
  name: "Course",
  data() {
    return {
      loading: false,
      isOn: '0',
      tabs: [
        { id: '0', name: '学习中' },
        { id: '1', name: '已完成' },
        { id: '-1', name: '非专业课程' },
      ],
      list: [],
      tsItem:{},
      courseLogo: require(`@/assets/login/kc.png`),
      examConfigList: [],
      form: {
        examConfigId: null
      },
      currentTime: null,
    };
  },
  computed: {
    ...mapState(['user']),
    currentExamConfig () {
      return this.examConfigList.find(item => item.id === this.form.examConfigId) || null
    },
    inStudyTime () {
      if (!this.currentExamConfig || !this.currentTime) return false
      const { studyStartTime, studyEndTime } = this.currentExamConfig
      if (!studyStartTime || !studyEndTime) return true
      const cur = this.currentTime instanceof Date ? this.currentTime.getTime() : this.parseTime(this.currentTime)
      const start = this.parseTime(studyStartTime)
      const end = this.parseTime(studyEndTime)
      if (!cur || !start || !end) return false
      return cur >= start && cur <= end
    }
  },
  async mounted() {
    await this.refreshCurrentTime();
    this.getExamConfig()
  },
  methods: {
    parseTime (time) {
      if (!time) return null
      const str = String(time).replace(/-/g, '/')
      const t = new Date(str).getTime()
      return isNaN(t) ? null : t
    },
    async refreshCurrentTime () {
      this.currentTime = await getServerCurrentTime(this.$http)
    },
    async getExamConfig() {
      await this.$http.get('/student/pc/getSchoolExamConfig', {}).then((res) => {
        this.examConfigList = res || [];
        if (this.examConfigList.length > 0) {
           this.form.examConfigId = res[0].id
        }
        this.getData();
      })
    },
    async getData() {
      if (this.form.examConfigId) {
        if (this.isOn === '-1') {
          this.$http.get('/student/pc/courseware/getMyCourse', {status: this.isOn, ...this.form}).then((res) => {
            this.list = res
          })
        } else {
          this.$http.get('/student/pc/study/promise/record/isSigned?examConfigId=' + this.form.examConfigId, {
          }).then((res) => {
            if (!res) {
              this.$refs.FightersAgreementDialog.open(this.form.examConfigId);
            }else{
              this.$http.get('/student/pc/courseware/getMyCourse', {status:this.isOn,...this.form}).then((res) => {
                this.list = res
              })
            }
          })
        }
      }
    },
    tabClick(e) {
      this.isOn = e.id
      this.getData();
    },
    async toStudy(e) {
      if (!this.form.examConfigId) {
        this.$message.error('请选择考次')
        return
      }

      if(e.isPay!='1'){
        const { isHistory } = await this.$http.get('/student/pc/register/queryStudentInfo');
        if(isHistory=='1'){
          this.$confirm('该课程学习费尚未缴费，请缴费', '提示', {
            confirmButtonText: '缴费',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleGoToPay(e)
          })
        }else{
          this.$message.error('课程学习权限还未开通，请与助学点联系')
        }
      }else{
        this.tsItem=e
        if(e.openFaceRecognition){
          this.$refs.faceRecognition.open({ coursewareId: e.id, examConfigId: this.form.examConfigId })
          return
        }
        this.toStudys(e)
      }
    },
    toStudys(e=this.tsItem){
      this.$router.push({
        path: '/courseStudy',
        query:{
          id:e.id,
          examConfigId: this.form.examConfigId,
        }
      })
    },
    async changeExamConfig() {
      await this.refreshCurrentTime();
      this.getData();
    },
    handleGoToPay (e) {
      this.$http.post('/student/pc/chooseCourse/createOrder', [e.courseId]).then((res) => {
        if (res) {
          this.$refs.payDialog.open(res)
        }
      })
    },
    onPledgeConfirm(pledgeData) {
      
    },
  },
};
</script>
<style lang="scss" scoped>
.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.newMine_base_tabs {
  width: 100%;
  height: 40px;
  background: rgb(245, 247, 250);

  p {
    width: 80px;
    text-align: center;
    margin: 0 30px;
    font-size: 16px;
    cursor: pointer;
    line-height: 40px;
    position: relative;
    color: rgb(51, 51, 51);
  }

  i {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 4px;
    background-color: transparent;
    background: transparent;
  }

  .on {
    color: #0065BA;
  }

  .bgColor {
    background: #0065BA;
  }
}

.newMine_coursePage_list {

  box-sizing: border-box;
  padding: 15px 30px 1px 30px;
}

.newMine_coursePage_li {
  width: 100%;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #E3E3E3;
  box-sizing: border-box;
  padding: 12px 10px;
  margin-bottom: 30px;

  .newMine_coursePage_li_img {
    width: 150px;
    height: 85px;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #F4F4F4;
  }

  .newMine_coursePage_li_info {
    margin-left: 15px;
    height: 85px;

    .newMine_coursePage_li_info_name {
      font-size: 16px;
      color: #333333;
    }

    .txtOver {
      width: 441px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }

    .newMine_coursePage_li_info_desc {
      height: 44px;
      color: #666;
      font-size: 14px;
    }

    .newMine_coursePage_li_info_descLi {
      margin-right: 55px;
    }

    .newMine_coursePage_li_info_desc p {
      margin-right: 5px;
    }

    .newMine_coursePage_li_info_icon {
      margin-right: 5px;
      height: 14px;
    }

    .newMine_coursePage_li_info_desc p {
      margin-right: 5px;
    }

    .newMine_coursePage_li_info_lineTxt {
      color: #999;
      font-size: 12px;
    }

    .newMine_coursePage_li_info_lineBox {
      width: 340px;
      height: 4px;
      background: #EDEDED;
      border-radius: 4px 4px 4px 4px;
      position: relative;
      overflow: hidden;
      margin-left: 20px;

      p {
        height: 4px;
        background: #FFA800;
      }
    }
  }

}

.newMine_BoxLi_btn {
  width: 74px;
  height: 28px;
  line-height: 28px;
  border-radius: 14px 14px 14px 14px;
  text-align: center;
  color: #fff;
}

.enroll-time {
  margin-left: 12px;
  color: #666;
  font-size: 13px;
  margin: 20px 0 0 30px;
}
</style>
